module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    staticClass: "modal-fade",
    attrs: {
      "name": "modal-fade"
    }
  }, [_c('div', {
    staticClass: "modal-backdrop"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitSession.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "session-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_vm._v("Enter Session Name")]
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "session-modal-body"
  }, [_c('label', {
    attrs: {
      "for": "sessionName"
    }
  }, [_vm._v("Session Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sessionName),
      expression: "sessionName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "id": "sessionName",
      "required": ""
    },
    domProps: {
      "value": (_vm.sessionName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sessionName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.close
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
      staticClass: "btn btn-green",
      attrs: {
        "type": "submit",
        "value": "Submit"
      }
    })]
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c8428f34","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/createSandboxSession.vue
// module id = jXuj
// module chunks = 1